import request from '@/utils/request'

export function login(data) {
  return request('/api/login', {
    method: 'POST',
    body: data,
    suppressErrorMessage: true
  })
}

export function getInfo() {
  return request('/api/admin/profile')
}

export function logout() {
  return request('/api/logout', {
    method: 'POST'
  })
}

export function changeSelfPassword(oldPassword, password) {
  return request('/api/password', {
    method: 'PATCH',
    body: {
      old_password: oldPassword,
      password
    }
  })
}
